<template>
    <div class="container-fluid">
        <div class="table-heading" :style="getTableHeadingStyle">
            <div class="row" :style="getRowPaddingAndMargin">
                <div class="col" v-for="tableHead in config.tableHeaders">{{tableHead.label}}</div>
            </div>
        </div>
        <div class="table-body" >
            <div class="row" :style="getDataRowStyle" v-for="data in maxedData">
                <div class="col"  v-for="tableHead in config.tableHeaders">
                    {{data[tableHead.key]}}
                </div>

            </div>
        </div>
    </div>

</template>


<script>
    export default {
        name: 'counter',
        props: {
            config: {},
            componentData: {},


        },
        data() {
            return {}
        },
        computed: {
            maxedData(){

                return _.take(this.componentData,this.config.rowLimit);
            },
            getTableHeadingStyle() {
                var CSS_STRING = "text-transform: uppercase !important;"
                CSS_STRING += "background:" + this.config.tableHeading.background + ";"
                CSS_STRING += "color: " + this.config.tableHeading.color + ";"
                CSS_STRING += "font-weight: " + this.config.tableHeading.fontWeight + ";"

                return CSS_STRING
            },
            getDataRowStyle() {
                var CSS_STRING = "text-transform: uppercase !important;"
                CSS_STRING += "background:" + this.config.dataRow.background + ";"
                CSS_STRING += "color: " + this.config.dataRow.color + ";"
                CSS_STRING += "padding:" + this.config.row.padding + ";"
                CSS_STRING += "margin:" + this.config.row.margin+" 0 "+ this.config.row.margin+";"


                return CSS_STRING
            },
            getRowPaddingAndMargin() {
                var CSS_STRING = ""
                CSS_STRING += "padding:" + this.config.row.padding + ";"
                CSS_STRING += "margin:" + this.config.row.margin+" 0 "+ this.config.row.margin+";"
                return CSS_STRING
            },
            getColPadding() {
                return 'padding:' + this.config.row.padding + ";"
            }
        },
        methods: {},
        created() {


        }
    }
</script>
<style lang="scss" scoped>

    .container-fluid {
        font-size:30px;
        background: transparent;
    }
</style>